Object.defineProperty(Number.prototype, "toCurrency", {
  value: function (locale = "fr-CA"): string {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: "CAD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(this);
  },
  writable: true,
  configurable: true,
});